import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import axios from "axios";

function PigmyPageModal() {
  const [open, setOpen] = useState(false);
  const [heading, setHeading] = useState("");
  const [paragraphs, setParagraphs] = useState([""]);

  const fetchContent = async () => {
    try {
      const res = await axios.get(`/api/pigmy-deposit`);  // Fixed route to '/api/pigmy-deposit'
      if (res.data) {
        setHeading(res.data.heading || "");
        setParagraphs(res.data.paragraphs || [""]);
      }
    } catch (err) {
      console.error("Error fetching content", err);
    }
  };

  const toggleModal = () => {
    if (!open) fetchContent();
    setOpen(!open);
  };

  const handleParagraphChange = (index, value) => {
    const updated = [...paragraphs];
    updated[index] = value;
    setParagraphs(updated);
  };

  const addParagraph = () => setParagraphs([...paragraphs, ""]);
  const removeParagraph = (index) => {
    const updated = [...paragraphs];
    updated.splice(index, 1);
    setParagraphs(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/api/pigmy-deposit`, {  // Fixed route to '/api/pigmy-deposit'
        heading,
        paragraphs,
      });
      alert("Content updated successfully!");
      toggleModal();
    } catch (err) {
      alert("Error saving content");
    }
  };

  return (
    <div className="modalDiv">
      <FaEdit className="icon-button" onClick={toggleModal} />

      <Popup
        open={open}
        closeOnDocumentClick={false}
        contentStyle={{ padding: "20px", width: "600px" }}
      >
        <a className="close" onClick={toggleModal}>
          &times;
        </a>
        <h3>Edit Page Content</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={heading}
            onChange={(e) => setHeading(e.target.value)}
            placeholder="Page Heading"
            required
            style={{ width: "100%", marginBottom: "10px" }}
          />

          {paragraphs.map((para, idx) => (
            <div key={idx} style={{ marginBottom: "10px" }}>
              <textarea
                value={para}
                onChange={(e) => handleParagraphChange(idx, e.target.value)}
                rows={3}
                style={{ width: "100%" }}
              />
              {paragraphs.length > 1 && (
                <button type="button" onClick={() => removeParagraph(idx)}>Delete</button>
              )}
            </div>
          ))}

        
          <br /><br />
          <button type="submit">Save</button>
        </form>
      </Popup>
    </div>
  );
}

export default PigmyPageModal;
